import React from "react";
import { List, Table } from "antd";

export default ({shopId}) => {
    const [accounts, setAccounts] = React.useState([]);

    React.useEffect(() => {
        fetchAccounts().then((data) => {

            if (data && data.length > 0) {
                setAccounts(data);
            }
        });
    }, []);

    const fetchAccounts = async () => {
        // Simulate fetching data from an API
        const response = await fetch('/api/account/user-list'+'?shopId='+shopId);
        const result = await response.json();

        if(result.success) {
            return result.data;
        }

        return [];
    }

    const columns = [
        {
            title: '账号',
            dataIndex: 'username',
        },
        {
            title: '角色',
            dataIndex: 'roleId_role_role_users',
            render: (text, record) => {
                return record.roleId_role_role_users.map(role => role.roleTitle).join('|');
            }
        },
        {
            title: '类型',
            dataIndex: 'isSub',
            render: (text, record) => {
                return text === true ? '子账号' : '主账号';
            }
        },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => {
                if(record.isSuper) {
                    return (<a href={`/account/create?userId=${record.userId}`}>编辑</a>);
                }else {
                    return (<>
                        <a href={`/account/create?userId=${record.userId}`}>编辑</a>
                        {/* <a onClick={() => {}}>禁用</a> */}
                    </>);
                }
            },
        }
    ]

    return (
        <Table rowKey={'userId'} size="small" columns={columns} dataSource={accounts} />
    );  
}